import {MyBusiness} from '../../models/my-business';
import {PaylinkSubscription} from '../../models/paylink-subscription';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {EnvironmentService} from '../../services/environment.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {ChangeMerchantPackageRequest} from '../../models/change-merchant-package-request';
import {MerchantPaylinkPaymentResponse} from '../../models/merchant-paylink-payment-response';
import {PackagePanelComponent, PaymentVia} from '../settings/package-panel/package-panel.component';
import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

declare var $: any;
declare var Snackbar: any;


@Component({
  selector: 'app-renew-subscription',
  templateUrl: 'renew-subscription.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, PackagePanelComponent],
  styleUrls: ['renew-subscription.component.scss']
})
export class RenewSubscriptionComponent implements OnInit {

  loading: any;
  form: FormGroup;
  lang: any;
  submitted: boolean;
  myBusiness: MyBusiness;
  submitting: boolean;
  selectedSubscription: PaylinkSubscription;
  data: ChangeMerchantPackageRequest;

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  get f() {
    return this.form.controls;
  }

  get v() {
    return this.form.value;
  }

  async ngOnInit() {
    this.loading = true;
    this.submitting = false;
    this.myBusiness = await this.api.getMyBusiness(true);

    this.selectedSubscription = this.myBusiness.paylinkSubscription;

    setTimeout(async () => {
      await this.loadResources();
      this.lang = await this.translate.get('lang').toPromise();
      this.loading = false;
    }, 1000);
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    console.log('');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    console.log('');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    console.log('');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');

    $('.dropify').dropify({
      messages: {
        'default': await this.translate.get('Click to Upload or Drag n Drop').toPromise(),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await this.translate.get('Upload or Drag n Drop').toPromise()
      }
    });
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  async reloadPage() {
    location.reload();
  }

  async paymentSubmittedAgain() {
    if (await this.sendPaymentToServer(this.data)) { // if payment sent to server, show popup and redirect.
      $('#minusPlanOkModal').modal('show');
    }
  }

  async continueAfterPayment() {
    await this.router.navigateByUrl('/private/settings');
  }

  async paymentSubmitted(data: ChangeMerchantPackageRequest) {
    this.submitting = true;
    if (this.myBusiness.walletAmount < data.amount && data.paymentVia != PaymentVia.BankCard) {
      this.data = data;
      $('#proceedModal').modal('show');
    } else {
      if (await this.sendPaymentToServer(data)) {
        await this.showToast(await this.translate.get('My package renewed successfully').toPromise());
        setTimeout(async () => {
          await this.router.navigateByUrl('/private/settings');
        }, 3000);
      }
    }
  }

  private async sendPaymentToServer(data: ChangeMerchantPackageRequest) {
    try {
      let result: MerchantPaylinkPaymentResponse = await this.api.postMerchantPackageRenew(
        data.subscriptionId,
        data.paymentPlan,
        data.paymentVia,
        data.amount,
      );
      if (result.paymentUrl) {
        await this.showToast(await this.translate.get('You will be redirected to payment page').toPromise());
        setTimeout(async () => {
          window.location.href = result.paymentUrl;
        }, 3000);
      } else {
        return true;
      }
    } catch (e) {
      if (e.error.title) {
        this.showToast(await this.translate.get(e.error.title).toPromise());
      } else {
        this.showToast(await this.translate.get('Could not change my package. Try again').toPromise());
      }
      this.submitting = false;
      this.submitted = false;
    }
  }

}




























